import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useExperiments } from '@hungryroot/experiments';
import { PUBLIC_GOOGLE_ANALYTICS_ID, PUBLIC_GOOGLE_OPTIMIZE_KEY } from '../ga';

interface EventTrackingGA {
  category: string;
  action: string;
  label?: string;
  value?: number;
  nonInteraction?: boolean;
}

export function useGoogleAnalytics() {
  useEffect(() => {
    ReactGA.initialize(PUBLIC_GOOGLE_ANALYTICS_ID, {
      testMode: process.env.NODE_ENV === 'test',
    });

    ReactGA.ga('require', PUBLIC_GOOGLE_OPTIMIZE_KEY);
  }, []);

  const experiments = useExperiments();
  const { data, isFetched: expOptimizeIdFetched } = experiments;
  const allExperiments = data?.results;
  const experimentOptimizeId = allExperiments?.find(
    (exp) => exp.optimize_id !== null
  )?.optimize_id;

  useEffect(() => {
    if (expOptimizeIdFetched && experimentOptimizeId) {
      ReactGA.set({ exp: experimentOptimizeId });
    }
  }, [expOptimizeIdFetched, experimentOptimizeId]);

  return {
    pageViewTrackingGA: (pathnameAndSearch: string) => {
      ReactGA.pageview(pathnameAndSearch);
    },
    setGA: (dimension: string, value: string) => {
      ReactGA.set({ [dimension]: value });
    },
    eventTrackingGA: ({
      category,
      action,
      label,
      value,
      nonInteraction,
    }: EventTrackingGA) => {
      ReactGA.event({
        category,
        action,
        label,
        value,
        nonInteraction,
      });
    },
  };
}
